interface Dictionary {
    [x: string]: string;
  };
  

export const me: Dictionary[] = [
]
